module.exports = __webpack_public_path__ + "img/onboarding_web_3.b03e001a.png";